import { render } from "./NearbyVendor.vue?vue&type=template&id=3c5c1abf"
import script from "./NearbyVendor.vue?vue&type=script&lang=js"
export * from "./NearbyVendor.vue?vue&type=script&lang=js"

import exportComponent from "F:\\App-themes\\clickon\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__